import styles from "../../styles/applicationDetail.module.css";
import type { CreditReportEmptySectionProps } from "../../types";

export function CreditReportEmptySection({ tab }: CreditReportEmptySectionProps) {
  const { showCreditReportEmptyState } = tab;

  if (!showCreditReportEmptyState) return null;

  return (
    <div className={styles.section} data-testid="application-credit-report-tab-section-empty">
      <p data-testid="application-credit-report-tab-empty-message">No credit report available.</p>
    </div>
  );
}
